import Vue from 'vue'
import Router from 'vue-router'
import newapp from '../../newapp.vue'

/* 前台 */
import index from '@/pages/index'
import integralshop from '@/pages/integralshop'
import discount from '@/pages/active/discount'
import tosellout from '@/pages/active/tosellout'
import tomorrow from '@/pages/active/tomorrow'
import Register from '@/pages/Register'
import Login from '@/pages/login'
import authLogin from '@/pages/authLogin'
import findPasswordType from '@/pages/FindPasswordType'
import findPassword from '@/pages/FindPassword'
import findPasswordReset from '@/pages/findPasswordReset'
import emailFindPassword from '@/pages/emailFindPassword'
import emailFindPasswordReset from '@/pages/emailFindPasswordReset'
import canvassList from '@/pages/canvassList'
import canvassDetail from '@/pages/canvassDetail'
import noticeDetail from '@/pages/noticeDetail'
import Address from '@/pages/Address'
import loaded from '@/pages/loaded'

import information from '@/pages/information'
import informationDetail from '@/pages/informationDetail'
import informationImgDetail from '@/pages/informationImgDetail'
import helperCenter from '@/pages/helperCenter'
import helperList from '@/pages/helperList'
import helperDetail from '@/pages/helperDetail'

import openSalesmanShop from '@/pages/openSalesmanShop'

/* 品牌商推广页 */
import brandStoreIndex from '@/pages/brandStore/index'
import jizhixinqin from '@/pages/brandStore/jizhixinqin'
import maizhiyuan from '@/pages/brandStore/maizhiyuan'
import nonggubuluo from '@/pages/brandStore/nonggubuluo'
import xinhewan from '@/pages/brandStore/xinhewan'
import yaodianzhensuo from '@/pages/brandStore/yaodianzhensuo'

/*优惠券 */
import couponUse from '@/pages/retail/coupon/couponUse'
import getCouponCenter from '@/pages/retail/coupon/getCouponCenter'
import myCoupon from '@/pages/retail/coupon/myCoupon'
import couponDiscount from '@/pages/retail/coupon/couponDiscount'
import shareGetCoupon from '@/pages/retail/coupon/shareGetCoupon'
import couponUsingRemark from '@/pages/retail/coupon/couponUsingRemark'
import couponcenter from '@/pages/retail/coupon/CouponCenter'

/* 微信 */
import wechatBind from '@/pages/wechatBind'


/* 支付宝 */
import alipayInit from '@/pages/retail/pay/alipayInit'
import alipayGo from '@/pages/retail/pay/alipayGo'
import alipaySend from '@/pages/retail/pay/alipaySend'


/*个人中心*/
import ucIndex from '@/pages/usercenter/ucindex'
import coin from '@/pages/usercenter/coin'
import coinWithdraw from '@/pages/usercenter/coinWithdraw'
import coinRecharge from '@/pages/usercenter/coinRecharge'
import coinTransfer from '@/pages/usercenter/coinTransfer'
import coinStream from '@/pages/usercenter/coinstream'
import coinDetail from '@/pages/usercenter/coindetail'

import myMoneyCoreTxList from '@/pages/usercenter/myMoneyCoreTxList'
import myMoneyCoreTxdetail from '@/pages/usercenter/myMoneyCoreTxdetail'

import integral from '@/pages/usercenter/integral'
import baw from '@/pages/usercenter/baw/net/baw'
import bawDetail from '@/pages/usercenter/baw/net/bawDetail'
import bawActive from '@/pages/usercenter/baw/net/bawActive'
import bawStream from '@/pages/usercenter/baw/net/bawStream'
import bawRecharge from '@/pages/usercenter/baw/net/bawRecharge'
import bawRechargePay from '@/pages/usercenter/baw/net/bawRechargePay'
import bawTransfer from '@/pages/usercenter/baw/net/bawTransfer'
import sun from '@/pages/usercenter/sun'
import sunActive from '@/pages/usercenter/sunActive'
import sunRecharge from '@/pages/usercenter/sunRecharge'
import sunWithdraw from '@/pages/usercenter/sunWithdraw'
import sunStream from '@/pages/usercenter/sunStream'
import sunDetail from '@/pages/usercenter/sunDetail'
import wua from '@/pages/usercenter/wua'
import wuaActive from '@/pages/usercenter/wuaActive'
import wuaRecharge from '@/pages/usercenter/wuaRecharge'
import wuaWithdraw from '@/pages/usercenter/wuaWithdraw'
import wuaStream from '@/pages/usercenter/wuaStream'
import wuaDetail from '@/pages/usercenter/wuaDetail'
import option from '@/pages/usercenter/option'
import person from '@/pages/usercenter/person'
import address from '@/pages/usercenter/address'
import addressEdit from '@/pages/usercenter/addressedit'
import safe from '@/pages/usercenter/safe'
import fav from '@/pages/usercenter/fav'
import shopFav from '@/pages/usercenter/shopFav'
import allorderlist from '@/pages/usercenter/allorderlist'
import allordersearch from '@/pages/usercenter/allordersearch'
import orderlist from '@/pages/usercenter/orderlist'
import ordersearch from '@/pages/usercenter/ordersearch'
import orderdetail from '@/pages/usercenter/orderdetail'
import ordermodifyaddress from '@/pages/usercenter/ordermodifyaddress'
import orderEvaluate from '@/pages/usercenter/orderEvaluate'
import orderdelivery from '@/pages/usercenter/orderdelivery'
import sellservicelist from '@/pages/usercenter/sellservicelist'
import sellservicedetail from '@/pages/usercenter/sellservicedetail'
import sellservicerequest from '@/pages/usercenter/sellservicerequest'
import sellservicedelivery from '@/pages/usercenter/sellservicedelivery'
import sellservicemsg from '@/pages/usercenter/sellservicemsg'

import integralOrderList from '@/pages/usercenter/integralOrderList'
import integralOrderdetail from '@/pages/usercenter/integralOrderdetail'
import integralOrderEvaluate from '@/pages/usercenter/integralOrderEvaluate'
import integralOrderdelivery from '@/pages/usercenter/integralOrderdelivery'

import candyOrderList from '@/pages/usercenter/bawOrderList'
import candyOrderdetail from '@/pages/usercenter/bawOrderdetail'
import candyordermodifyaddress from '@/pages/usercenter/bawordermodifyaddress'
import candyOrderEvaluate from '@/pages/usercenter/bawOrderEvaluate'
import candyOrderdelivery from '@/pages/usercenter/bawOrderdelivery'
import candyOrdersearch from '@/pages/usercenter/bawOrdersearch'

import jktOrderList from '@/pages/usercenter/jktOrderList'
import jktOrderdetail from '@/pages/usercenter/jktOrderdetail'
import jktordermodifyaddress from '@/pages/usercenter/jktordermodifyaddress'
import jktOrderEvaluate from '@/pages/usercenter/jktOrderEvaluate'
import jktOrderdelivery from '@/pages/usercenter/jktOrderdelivery'
import jktOrdersearch from '@/pages/usercenter/jktOrdersearch'


import chainOrderList from '@/pages/usercenter/yscOrderList'
import chainOrderdetail from '@/pages/usercenter/yscOrderdetail'
import chainOrderEvaluate from '@/pages/usercenter/yscOrderEvaluate'
import chainOrderdelivery from '@/pages/usercenter/yscOrderdelivery'
import chainOrdersearch from '@/pages/usercenter/yscOrdersearch'

import ysc from '@/pages/usercenter/ysc/local/ysc'
import yscDetail from '@/pages/usercenter/ysc/local/yscDetail'
import yscActive from '@/pages/usercenter/ysc/local/yscActive'
import yscRecharge from '@/pages/usercenter/ysc/local/yscRecharge'
import yscWithdraw from '@/pages/usercenter/ysc/local/yscWithdraw'
import yscStream from '@/pages/usercenter/ysc/local/yscStream'

import jft from '@/pages/usercenter/jft/local/jft'
import jftDetail from '@/pages/usercenter/jft/local/jftDetail'
import jftActive from '@/pages/usercenter/jft/local/jftActive'
import jftRecharge from '@/pages/usercenter/jft/local/jftRecharge'
import jftWithdraw from '@/pages/usercenter/jft/local/jftWithdraw'
import jftStream from '@/pages/usercenter/jft/local/jftStream'
import jftIndex from '@/pages/jft/index'
import jftProductDetail from '@/pages/jft/productDetail'
import jftOrderSubmit from '@/pages/jft/orderSubmit'
import jftOrderPay from '@/pages/jft/orderPay'


import sign from '@/pages/usercenter/sign'
import ComplaintsSuggestions from '@/pages/usercenter/ComplaintsSuggestions'
import ComplaintsSuggestionsAdd from '@/pages/usercenter/ComplaintsSuggestionsAdd'
import passwordEdit from '@/pages/usercenter/passwordEdit'
import paypassword from '@/pages/usercenter/paypassword'
import paypasswordEdit from '@/pages/usercenter/paypasswordEdit'
import FindPayPasswordType from '@/pages/usercenter/FindPayPasswordType'
import paypasswordReset from '@/pages/usercenter/paypasswordReset'
import paypasswordResetByEmail from '@/pages/usercenter/paypasswordResetByEmail'
import mobileBind from '@/pages/usercenter/mobileBind'
import mobileChangeReset from '@/pages/usercenter/mobileChangeReset'
import mobileMove from '@/pages/usercenter/mobileMove'
import emailBind from '@/pages/usercenter/emailBind'
import emailChangeReset from '@/pages/usercenter/emailChangeReset'
import withdrawAccount from '@/pages/usercenter/withdrawAccount'
import withdrawAccountEdit from '@/pages/usercenter/withdrawAccountEdit'

import messageTypeList from '@/pages/usercenter/messageTypeList'
import messageServiceList from '@/pages/usercenter/messageServiceList'
import messageShoppingList from '@/pages/usercenter/messageShoppingList'

import pintuanOrderList from '@/pages/usercenter/pintuanOrderList'
import pintuanOrderdetail from '@/pages/usercenter/pintuanOrderdetail'
import pintuanOrderEvaluate from '@/pages/usercenter/pintuanOrderEvaluate'
import pintuanOrderSearch from '@/pages/usercenter/pintuanOrderSearch'
import pintuanOrderdelivery from '@/pages/usercenter/pintuanOrderdelivery'



/* 代理中心 */
import salemanindex from '@/pages/salesman/salesmanindex'
import salesmanProductIndex from '@/pages/salesman/salesmanProductIndex'
import salesmanProductDetail from '@/pages/salesman/productDetail'
import registerMember from '@/pages/salesman/registerMember'
import salesmanHelpGiftAddress from '@/pages/salesman/salesmanHelpGiftAddress'
import fenliuStream from '@/pages/salesman/fenliuStream'
import fenliuserver from '@/pages/salesman/fenliuserver'
import fenliustore from '@/pages/salesman/fenliustore'
import fenxiang from '@/pages/salesman/fenxiang'
import myaward from '@/pages/salesman/myaward'
import awardstream from '@/pages/salesman/awardstream'
import mybonus from '@/pages/salesman/mybonus'
import mybonuslist from '@/pages/salesman/mybonuslist'
import mybonusdetail from '@/pages/salesman/mybonusdetail'
import mycard from '@/pages/salesman/mycard'
import mydaili from '@/pages/salesman/mydaili'
import mydaililist from '@/pages/salesman/mydaililist'
import mydingdan from '@/pages/salesman/mydingdan'
import mymember from '@/pages/salesman/mymember'
import mymemberlist from '@/pages/salesman/mymemberlist'
import mymemberviplist from '@/pages/salesman/mymemberviplist'
import mytuijian from '@/pages/salesman/mytuijian'
import mytuijianlist from '@/pages/salesman/mytuijianlist'
import myzhaoshang from '@/pages/salesman/myzhaoshang'
import salesmanSetting from '@/pages/salesman/setting'
import tuiguang from '@/pages/salesman/tuiguang'
import salesmanOrderSubmit from '@/pages/salesman/orderSubmit'
import salesmanOrderPay from '@/pages/salesman/orderPay'
import salesmanorderlist from '@/pages/salesman/orderlist'
import salesmanorderdetail from '@/pages/salesman/orderdetail'
import salesmandelivery from '@/pages/salesman/delivery'
import salesmanorderdelivery from '@/pages/salesman/orderdelivery'
import salesmangift from '@/pages/salesman/salesmanGift'
import salesmangiftaddress from '@/pages/salesman/salesmanGiftAddress'
import salesmanviporderlist from '@/pages/salesman/viporderlist'
import salesmanviporderdetail from '@/pages/salesman/viporderdetail'
import salesmanvipordermodifyaddress from '@/pages/salesman/vipordermodifyaddress'

import purchasecoin from '@/pages/salesman/purchasecoin'
import purchasecoinStream from '@/pages/salesman/purchasecoinstream'
import purchasecoinDetail from '@/pages/salesman/purchasecoindetail'

import purchaseorderlist from '@/pages/salesman/purchaseorderlist'
import purchaseordermodifyaddress from '@/pages/salesman/purchaseordermodifyaddress'
import purchaseordersearch from '@/pages/salesman/purchaseordersearch'
import purchaseorderdetail from '@/pages/salesman/purchaseorderdetail'
import purchaseorderEvaluate from '@/pages/salesman/purchaseorderEvaluate'
import purchaseorderdelivery from '@/pages/salesman/purchaseorderdelivery'

import shangquanaddressPage from '@/pages/shangquan/sqaddress'
import shangquanfenleiPage from '@/pages/shangquan/fenlei'
import shangquanindexPage from '@/pages/shangquan/sqindex'
import shangquanSearchPage from '@/pages/shangquan/sqSearch'
import shangquanmaidanPage from '@/pages/shangquan/maidan'
import shangquanpingjiaPage from '@/pages/shangquan/pingjia'
import shangquanpingjiaEvaluatePage from '@/pages/shangquan/sqEvaluate'
import shangquanpingjiaImgPage from '@/pages/shangquan/sqEvaluateImg'
import shangquantemaiPage from '@/pages/shangquan/temai'
import shangquanzizhiPage from '@/pages/shangquan/zizhi'
import shangquanMapPage from '@/pages/shangquan/sqMap'
import shangquandetailPage from '@/pages/shangquan/shangquandetail'
import shangquanPayPage from '@/pages/shangquan/sqPay'
import shangquanPaySuccessPage from '@/pages/shangquan/sqPaySuccess'
import shangquanPayFailedPage from '@/pages/shangquan/sqPayFailed'
import shangquanofflinePayListPage from '@/pages/shangquan/offlinePayList'
import shangquanofflinePaySearchPage from '@/pages/shangquan/offlinePaySearch'
import shangquanofflinePayEvaluatePage from '@/pages/shangquan/offlinePayEvaluate'

/* 零售 */
import category from '@/pages/retail/category'
import search from '@/pages/retail/search'
import productList from '@/pages/retail/newproductList'
import productDetail from '@/pages/retail/productDetail'
import productDetailEvaluate from '@/pages/retail/productDetailEvaluate'
import productDetailImg from '@/pages/retail/productDetailImg'
import cartRetail from '@/pages/retail/cart'
import retailOrderSubmit from '@/pages/retail/orderSubmit'
import buyNowOrderSubmit from '@/pages/retail/buyNowOrderSubmit'
import retailOrderPay from '@/pages/retail/orderPay'
import retailOrderPaySuccess from '@/pages/retail/orderPaySuccess'
import retailOrderPayFailed from '@/pages/retail/orderPayFailed'
import SelectSelfPickUp from '@/pages/retail/SelectSelfPickUp'

import integralOrderSubmit from '@/pages/integral/orderSubmit'
import integralOrderPay from '@/pages/integral/orderPay'

import bawlogin from '@/pages/bawLogin'
import bawIndex from '@/pages/baw/index'
import bawProductDetail from '@/pages/baw/productDetail'
import bawOrderSubmit from '@/pages/baw/orderSubmit'
import bawOrderPay from '@/pages/baw/orderPay'

import yscIndex from '@/pages/ysc/index'
import yscProductDetail from '@/pages/ysc/productDetail'
import yscOrderSubmit from '@/pages/ysc/orderSubmit'
import yscOrderPay from '@/pages/ysc/orderPay'

import shopIndex from '@/pages/shop/shouye'


import wallet from '@/pages/IHNY/wallet'
import ucinfo from '@/pages/IHNY/ucinfo'

/* 批发 */
import wholesaleIndex from '@/pages/wholesale/index'
import purchaseSearch from '@/pages/wholesale/search'
import purchaseProductList from '@/pages/wholesale/productList'
import purchaseProductDetail from '@/pages/wholesale/productDetail'
import cartPurchase from '@/pages/wholesale/cart'
import purchaseOrderSubmit from '@/pages/wholesale/orderSubmit'
import purchaseOrderPay from '@/pages/wholesale/orderPay'
import purchaseOrderPaySuccess from '@/pages/wholesale/orderPaySuccess'
import purchaseOrderPayFailed from '@/pages/wholesale/orderPayFailed'
import purchaseSelectSelfPickUp from '@/pages/wholesale/SelectSelfPickUp'


import groupShopListPage from '@/pages/groupShop/groupShopList'
import groupProductListPage from '@/pages/groupShop/groupProductList'
import groupShopSharPage from '@/pages/groupShop/groupShopShar' 
import groupShopSuccessPage from '@/pages/groupShop/groupShopSuccess' 
import groupShopSubmitPage from '@/pages/groupShop/groupShopSubmit' 
import groupShopQRCodePage from '@/pages/groupShop/groupShopQRCode'
import orderPayPage from '@/pages/groupShop/orderPay'


Vue.use(Router)
Router.prototype.goBack = function () {
  this.isBack = true
  window.history.go(-1)
}
export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: newapp,
      children:[
        {
          path: '/',
          name: 'index',
          component: index
        },
        {
          path: '/bawlogin',
          component: bawlogin
        },
        {
          path: '/baw/index',
          component: bawIndex
        },
		{
          path: '/ysc/index',
          component: yscIndex
        },
		{
          path: '/usercenter/ysc',
          component: ysc,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
        },
        {
          path: '/usercenter/yscDetail',
          component: yscDetail,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
        },
        {
          path: '/usercenter/yscActive',
          component: yscActive,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
         },          
        },
        {
          path: '/usercenter/yscRecharge',
          component: yscRecharge,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/yscWithdraw',
          component: yscWithdraw,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/yscStream',
          component: yscStream,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },
        },
        
        {
          path: '/usercenter/jft',
          component: jft,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
        },
        {
          path: '/usercenter/jftDetail',
          component: jftDetail,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
        },
        {
          path: '/usercenter/jftActive',
          component: jftActive,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
         },          
        },
        {
          path: '/usercenter/jftRecharge',
          component: jftRecharge,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/jftWithdraw',
          component: jftWithdraw,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/jftStream',
          component: jftStream,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },
        },
		{
          path: '/jft/index',
          component: jftIndex
        },
		{
          path: '/jft/productDetail',
          component: jftProductDetail,
          meta: {
            title: ''
           },    
        },
        {
          path: '/jft/orderSubmit',
          component: jftOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/jft/orderPay',
          component: jftOrderPay,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/integralshop',
          component: integralshop
        },
        {
          path: '/active/discount',
          component: discount
        },
        {
          path: '/active/tomorrow',
          component: tomorrow
        },
        {
          path: '/active/tosellout',
          component: tosellout
        },
        {
          path: '/Register',
          component: Register
        },
        {
          path: '/Login',
          component: Login
        },
        {
          path: '/authLogin',
          component: authLogin
        },
        {
          path: '/findPasswordType',
          component:findPasswordType
        },
        {
          path: '/FindPassword',
          component:findPassword
        },
        {
          path: '/FindPasswordReset',
          component:findPasswordReset
        },
        {
          path: '/emailFindPassword',
          component:emailFindPassword
        },
        {
          path: '/emailFindPasswordReset',
          component:emailFindPasswordReset
        },
        {
          path: '/canvassList',
          component:canvassList
        },
        {
          path: '/canvassDetail',
          component:canvassDetail
        },
        {
          path: '/noticeDetail',
          component:noticeDetail
        },
        {
          path: '/wechatBind',
          component:wechatBind
        },
        
       {
        path: '/information',
        component: information
       },
         {
           path: '/informationDetail',
          component: informationDetail        
       },
        {
           path: '/informationImgDetail',
          component: informationImgDetail      
         },
		
        {
          path: '/Address',
          component:Address
        },
        {
          path: '/loaded',
          component:loaded
        },
       
        
        {
          path: '/brandStore/index',
          component: brandStoreIndex      
        },
        {
           path: '/brandStore/jizhixinqin',
           component: jizhixinqin      
         },
         {
           path: '/brandStore/maizhiyuan',
           component: maizhiyuan      
         },
         {
           path: '/brandStore/nonggubuluo',
           component: nonggubuluo      
         },
         {
           path: '/brandStore/xinhewan',
           component: xinhewan      
         },
         {
           path: '/brandStore/yaodianzhensuo',
           component: yaodianzhensuo      
         },
         {
           path: '/helperCenter',
           component: helperCenter   
         },  
         {
           path: '/helperList',
           component: helperList    
         }, 
         {
           path: '/helperDetail',
           component: helperDetail    
         }, 

         {
           path: '/openSalesmanShop',
           component: openSalesmanShop    
         }, 

        {
          path: '/usercenter/index',
          component: ucIndex,
          meta:{
            appRequireAuth : true
          }         
        },
        {
          path: '/usercenter/coin',
          component: coin,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/coinWithdraw',
          component: coinWithdraw,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/coinRecharge',
          component: coinRecharge,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/coinTransfer',
          component: coinTransfer,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/coinStream',
          component: coinStream,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/coinDetail',
          component: coinDetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/myMoneyCoreTxList',
          component: myMoneyCoreTxList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/myMoneyCoreTxdetail',
          component: myMoneyCoreTxdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/integral',
          component: integral,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/baw',
          component: baw,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
        },
        {
          path: '/usercenter/bawDetail',
          component: bawDetail,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
        },
        {
          path: '/usercenter/bawActive',
          component: bawActive,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
         },          
        },
        {
         path: '/usercenter/bawStream',
         component: bawStream,
         meta: {
           title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
        },
       }, 
        {
         path: '/usercenter/bawRecharge',
         component: bawRecharge,
         meta: {
           title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
        },          
       },
        {
         path: '/usercenter/bawRechargePay',
         component: bawRechargePay,
         meta: {
           title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
        },          
       },
        {
         path: '/usercenter/bawTransfer',
         component: bawTransfer,
         meta: {
           title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
        },          
       },
        {
          path: '/usercenter/sun',
          component: sun,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
        },
        {
          path: '/usercenter/sunActive',
          component: sunActive,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
         },          
        },
        {
          path: '/usercenter/sunRecharge',
          component: sunRecharge,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sunWithdraw',
          component: sunWithdraw,
          meta: {
            title: '',
           requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sunStream',
          component: sunStream,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sunDetail',
          component: sunDetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
         {
           path: '/usercenter/wua',
           component: wua,
           meta: {
             title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
         },
         {
           path: '/usercenter/wuaActive',
           component: wuaActive,
           meta: {
             title: '',
             requireAuth: true, // 该字段表示进入这个路由是需要登录的
          },          
         },
         {
           path: '/usercenter/wuaRecharge',
           component: wuaRecharge,
           meta: {
             title: '',
             requireAuth: true, // 该字段表示进入这个路由是需要登录的
            },          
         },
         {
           path: '/usercenter/wuaWithdraw',
           component: wuaWithdraw,
           meta: {
             title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
            },          
         },
         {
           path: '/usercenter/wuaStream',
           component: wuaStream,
           meta: {
             title: '',
             requireAuth: true, // 该字段表示进入这个路由是需要登录的
            },          
         },
         {
           path: '/usercenter/wuaDetail',
           component: wuaDetail,
           meta: {
             title: '',
             requireAuth: true, // 该字段表示进入这个路由是需要登录的
            },          
         },
        {
          path: '/usercenter/option',
          component: option,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/person',
          component: person,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/safe',
          component: safe,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/address',
          component: address,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/addressEdit',
          component: addressEdit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/fav',
          component: fav,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/shopFav',
          component: shopFav,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/allorderlist',
          component: allorderlist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
		{
          path: '/usercenter/allordersearch',
          component: allordersearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/orderlist',
          component: orderlist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/ordersearch',
          component: ordersearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/orderdetail',
          component: orderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/orderEvaluate',
          component: orderEvaluate,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/orderModifyAddress',
          component: ordermodifyaddress,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/orderdelivery',
          component: orderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sellservicelist',
          component: sellservicelist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sellservicedetail',
          component: sellservicedetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sellservicerequest',
          component: sellservicerequest,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sellservicedelivery',
          component: sellservicedelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/sellservicemsg',
          component: sellservicemsg,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/integralOrderList',
          component: integralOrderList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/integralOrderdetail',
          component: integralOrderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/integralOrderEvaluate',
          component: integralOrderEvaluate,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/integralOrderdelivery',
          component: integralOrderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        
        {
          path: '/usercenter/candyOrderList',
          component: candyOrderList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/candyOrderdetail',
          component: candyOrderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/candyOrderEvaluate',
          component: candyOrderEvaluate,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/candyOrderdelivery',
          component: candyOrderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/candyordermodifyaddress',
          component: candyordermodifyaddress,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
		{
          path: '/usercenter/candyOrdersearch',
          component: candyOrdersearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },

        {
          path: '/usercenter/jktOrderList',
          component: jktOrderList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/jktOrderdetail',
          component: jktOrderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/jktOrderEvaluate',
          component: jktOrderEvaluate,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/jktOrderdelivery',
          component: jktOrderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/jktordermodifyaddress',
          component: jktordermodifyaddress,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
		{
          path: '/usercenter/jktOrdersearch',
          component: jktOrdersearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
		
		{
          path: '/usercenter/chainOrderList',
          component: chainOrderList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/chainOrderdetail',
          component: chainOrderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/chainOrderEvaluate',
          component: chainOrderEvaluate,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/chainOrderdelivery',
          component: chainOrderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
		{
          path: '/usercenter/chainOrdersearch',
          component: chainOrdersearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
		

        {
          path: '/usercenter/sign',
          component: sign,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/ComplaintsSuggestions',
          component: ComplaintsSuggestions,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/ComplaintsSuggestionsAdd',
          component: ComplaintsSuggestionsAdd,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/passwordEdit',
          component: passwordEdit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/paypassword',
          component: paypassword,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/paypasswordEdit',
          component: paypasswordEdit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/FindPayPasswordType',
          component: FindPayPasswordType,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/paypasswordReset',
          component: paypasswordReset,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/paypasswordResetByEmail',
          component: paypasswordResetByEmail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/mobileBind',
          component: mobileBind,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/mobileMove',
          component: mobileMove,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/mobileChangeReset',
          component: mobileChangeReset,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/emailBind',
          component: emailBind,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/emailChangeReset',
          component: emailChangeReset,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/withdrawAccount',
          component: withdrawAccount,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/usercenter/withdrawAccountEdit',
          component: withdrawAccountEdit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },       
        {
          path: '/usercenter/messageTypeList',
          component: messageTypeList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },    
        {
          path: '/usercenter/messageServiceList',
          component: messageServiceList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },      
        {
          path: '/usercenter/messageShoppingList',
          component: messageShoppingList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        }, 
        {
          path: '/usercenter/pintuanOrderList',
          component: pintuanOrderList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },    
        {
          path: '/usercenter/pintuanOrderdetail',
          component: pintuanOrderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },  
        {
          path: '/usercenter/pintuanOrderEvaluate',
          component: pintuanOrderEvaluate,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },   {
          path: '/usercenter/pintuanOrderSearch',
          component: pintuanOrderSearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },    {
          path: '/usercenter/pintuanOrderdelivery',
          component: pintuanOrderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },    


        {
          path: '/shangquan/address',
          component: shangquanaddressPage,
          meta: {
            title: ''
           },          
        },   
        {
          path: '/shangquan/fenlei',
          component: shangquanfenleiPage,
          meta: {
            title: ''
           },          
        },   
        {
          path: '/shangquan/index',
          component: shangquanindexPage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/search',
          component: shangquanSearchPage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/pingjia',
          component: shangquanpingjiaPage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/pingjiaImg',
          component: shangquanpingjiaImgPage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/shopMap',
          component: shangquanMapPage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/pingjiaEvaluate',
          component: shangquanpingjiaEvaluatePage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/temai',
          component: shangquantemaiPage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/zizhi',
          component: shangquanzizhiPage,
          meta: {
            title: ''
           },          
        },
        {
          path: '/shangquan/maidan',
          component: shangquanmaidanPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/shangquan/shangquandetail',
          component: shangquandetailPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/shangquan/pay',
          component: shangquanPayPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/shangquan/paySuccess',
          component: shangquanPaySuccessPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/shangquan/payFailed',
          component: shangquanPayFailedPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/shangquan/offlinePayList',
          component: shangquanofflinePayListPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/shangquan/offlinePaySearch',
          component: shangquanofflinePaySearchPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/shangquan/offlinePayEvaluate',
          component: shangquanofflinePayEvaluatePage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },



        {
          path: '/salesman/index',
          component: salemanindex,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/salesmanProductIndex',
          component: salesmanProductIndex,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/productDetail',
          component: salesmanProductDetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/registerMember',
          component: registerMember,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/helpGiftAddress',
          component: salesmanHelpGiftAddress,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/fenliuStream',
          component: fenliuStream,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/fenliuserver',
          component: fenliuserver,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/fenliustore',
          component: fenliustore,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/fenxiang',
          component: fenxiang,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/myaward',
          component: myaward,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/awardstream',
          component: awardstream,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mybonus',
          component: mybonus,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mybonuslist',
          component: mybonuslist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mybonusdetail',
          component: mybonusdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mycard',
          component: mycard,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mydaili',
          component: mydaili,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mydaililist',
          component: mydaililist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mydingdan',
          component: mydingdan,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mymember',
          component: mymember,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mymemberlist',
          component: mymemberlist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mymemberviplist',
          component: mymemberviplist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mytuijian',
          component: mytuijian,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mytuijianlist',
          component: mytuijianlist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/myzhaoshang',
          component: myzhaoshang,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/setting',
          component: salesmanSetting,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/tuiguang',
          component: tuiguang,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/mybonusdetail',
          component: mybonusdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/orderSubmit',
          component: salesmanOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/orderPay',
          component: salesmanOrderPay,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/orderlist',
          component: salesmanorderlist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/orderdetail',
          component: salesmanorderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/delivery',
          component: salesmandelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/orderdelivery',
          component: salesmanorderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/gift',
          component: salesmangift,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/giftAddress',
          component: salesmangiftaddress,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/vipOrderList',
          component: salesmanviporderlist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/vipordermodifyaddress',
          component: salesmanvipordermodifyaddress,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/vipOrderDetail',
          component: salesmanviporderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchasecoin',
          component: purchasecoin,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchasecoinStream',
          component: purchasecoinStream,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchaseordermodifyaddress',
          component: purchaseordermodifyaddress,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchasecoinDetail',
          component: purchasecoinDetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchaseorderlist',
          component: purchaseorderlist,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchaseordersearch',
          component: purchaseordersearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchaseorderdetail',
          component: purchaseorderdetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchaseorderEvaluate',
          component: purchaseorderEvaluate,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/salesman/purchaseorderdelivery',
          component: purchaseorderdelivery,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/wholesale/index',
          component: wholesaleIndex,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/search',
          component: purchaseSearch,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/productList',
          component: purchaseProductList,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/productDetail',
          component: purchaseProductDetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/cart',
          component: cartPurchase,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/orderSubmit',
          component: purchaseOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/orderPay',
          component: purchaseOrderPay,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/orderPaySuccess',
          component: purchaseOrderPaySuccess,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/orderPayFailed',
          component: purchaseOrderPayFailed,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/wholesale/selectSelfPickUp',
          component: purchaseSelectSelfPickUp,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },


        {
          path: '/shop/shopIndex',
          component: shopIndex
        },

        {
          path: '/retail/category',
          component: category
        },
        {
          path: '/retail/search',
          component: search
        },
        {
          path: '/retail/search',
          component: search
        },
        {
          path: '/retail/productList',
          component: productList
        },
        {
          path: '/retail/productDetail',
          component: productDetail
        },
        {
          path: '/retail/productDetailEvaluate',
          component: productDetailEvaluate
        },
        {
          path: '/retail/productDetailImg',
          component: productDetailImg
        },
        {
          path: '/retail/cart',
          component: cartRetail,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/retail/orderSubmit',
          component: retailOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/retail/buyNowOrderSubmit',
          component: buyNowOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/retail/orderPay',
          component: retailOrderPay,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },          
        },
        {
          path: '/retail/orderPaySuccess',
          component: retailOrderPaySuccess
        },
        {
          path: '/retail/orderPayFailed',
          component: retailOrderPayFailed
        },
        {
          path: '/integral/orderSubmit',
          component: integralOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/integral/orderPay',
          component: integralOrderPay,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/baw/productDetail',
          component: bawProductDetail,
          meta: {
            title: ''
           },    
        },
        {
          path: '/baw/orderSubmit',
          component: bawOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/baw/orderPay',
          component: bawOrderPay,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
		{
          path: '/ysc/productDetail',
          component: yscProductDetail,
          meta: {
            title: ''
           },    
        },
        {
          path: '/ysc/orderSubmit',
          component: yscOrderSubmit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/ysc/orderPay',
          component: yscOrderPay,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/retail/SelectSelfPickUp',
          component: SelectSelfPickUp,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        }, 
        {
          path: '/retail/pay/alipayInit',
          component: alipayInit,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },        
        {
          path: '/retail/pay/alipayGo',
          component: alipayGo,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },               
        {
          path: '/retail/pay/alipaySend',
          component: alipaySend,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/retail/coupon/couponUse',
          component: couponUse,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/retail/coupon/getCouponCenter',
          component: getCouponCenter,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的			
           },           				   
        },
        {
          path: '/retail/coupon/myCoupon',
          component: myCoupon,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/retail/coupon/couponDiscount',
          component: couponDiscount,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },     
        {
          path: '/retail/coupon/shareGetCoupon',
          component: shareGetCoupon,
          meta: {
            title: '',
            requireAuth: false, // 该字段表示进入这个路由是需要登录的
           },    
        },   
        {
          path: '/retail/coupon/couponUsingRemark',
          component: couponUsingRemark,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },      
        {
          path: '/retail/coupon/couponcenter',
          component: couponcenter,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
			msg: '请先登录再领券', // 未登录时的自定义提示
           },    
        },       
        {
          path: '/groupShop/groupShopList',
          component: groupShopListPage,
          meta: {
            title: ''
           },    
        },
        {
          path: '/groupShop/groupProductList',
          component: groupProductListPage,
          meta: {
            title: ''
           },    
        },
        {
          path: '/groupShop/groupShopShar',
          component: groupShopSharPage,
          meta: {
            title: ''
           },    
        },
        {
          path: '/groupShop/groupShopSuccess',
          component: groupShopSuccessPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },
        {
          path: '/groupShop/groupShopSubmit',
          component: groupShopSubmitPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        },  
        {
          path: '/groupShop/groupShopQRCode',
          component: groupShopQRCodePage,
          meta: {
            title: ''
           },    
        }, 
        {
          path: '/groupShop/orderPay',
          component: orderPayPage,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        }, 

        {
          path: '/IHNY/wallet',
          component: wallet,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        }, 
        {
          path: '/IHNY/ucinfo',
          component: ucinfo,
          meta: {
            title: '',
            requireAuth: true, // 该字段表示进入这个路由是需要登录的
           },    
        }, 
      ]
    }    
  ]
})


// WEBPACK FOOTER //
// ./src/router/xurigo/index.js